import React, { useState, useEffect, useRef } from "react";
import "./SideNav.css";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import ProjectService from "../../pages/all-projects/ProjectService";
import { FaEdit } from "react-icons/fa";
import { BsTrash } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import SideNavService from "./SideNavService";
import i18n from "i18next";
import { initReactI18next, useTranslation } from "react-i18next";
import translationEn from "../../translation/en/translation";
import translationDe from "../../translation/de/translation";
import { confirmDialog } from "primereact/confirmdialog";
import { Tooltip } from 'react-tooltip';
import { Menubar } from 'primereact/menubar';
import { Dropdown } from 'primereact/dropdown';
import ProjectDropdown from "../../pages/all-projects/ProjectDropdown";


if (localStorage.getItem("lang") === "de") {
  i18n.use(initReactI18next).init({
    resources: {
      en: { translation: translationEn },
      de: { translation: translationDe },
    },
    lng: "de",
    fallbackLng: "de",
    interpolation: { escapeValue: false },
  });
} else {
  i18n.use(initReactI18next).init({
    resources: {
      en: { translation: translationEn },
      de: { translation: translationDe },
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });
}

const SideNav = () => {
  const { t } = useTranslation();

  const toast = useRef<any>(null);
  const sideNavService = new SideNavService();
  const navigate = useNavigate();
  const [visible, setVisible] = useState<boolean>(false);
  const [projects, setProjects] = useState<any>([]);
  const projectService = new ProjectService();

  const showSuccess = (message: string) => {
    toast.current.show({
      severity: "success",
      summary: "Confirmation Message",
      detail: message,
      life: 3000,
    });
  };
  const deleteProjectInfo = (project: any) => {
    if(project === 'all-project'){
      const dropdownData = JSON.stringify({name: t("all_projects"), code: 0})
      localStorage.setItem('projectDropdown', dropdownData)
    }
    else{
      const dropdownData = JSON.stringify({code: project['id'], name: project['project_name']})
      localStorage.setItem('projectDropdown', dropdownData)
    }
    localStorage.removeItem("projectInfo");
    localStorage.removeItem("measurements");
    localStorage.removeItem("deviceMessaging");
    localStorage.removeItem("serverMessaging");
    localStorage.removeItem("transferInfo");
    localStorage.removeItem("eventSelect");
    localStorage.removeItem("eventsList");
    localStorage.removeItem("eventStrtTime");
    localStorage.removeItem("eventEndTime");
  };
  const refreshAPI = () => {
    projectService.getUserDetails().then((resp) => {
      localStorage.setItem("lang", resp["language"].trim());
      localStorage.setItem('timezone', resp['timezone']);
      projectService.getAssignedDevices(resp["id"], "").then((response) => {
        setProjects(response);
      });
    });
  };

  const confirmDelete = (projectId: any, projectName: string) => {
    confirmDialog({
      message: t('project_delete_message') + ` ${projectName}`,
      header: t('delete_confirmation'),
      icon: 'pi pi-info-circle',
      acceptClassName: 'p-button-danger',
      acceptLabel: t('yes'),
      rejectLabel: t('no'),
      accept:
        () => {
          sideNavService
            .deleteProject(projectId)
            .then((response) => {
              if (response.status === 200) {
                showSuccess(t('project_deleted'));
                refreshAPI();
                navigate("/");
                window.location.reload();
              }
            });
        },

    });
  };

  const shortenName = (nameString: string) => {
    if (nameString.length > 18) {
      return `${nameString.slice(0, 18)}...`;
    }
    else {
      return nameString
    }

  }
  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem("lang")!);
    refreshAPI();
  }, [i18n.language]);

  const getDropdownName = () =>{
    if(localStorage.getItem('projectDropdown')){
      let optionString = localStorage.getItem('projectDropdown');
      let option = optionString ? JSON.parse(optionString) : null;
      return option['name']
    }
    else{
      return t('projects');
    }
  }

  const items: any = [
    {
      label: getDropdownName(),
      icon: 'pi pi-server',
      items: [
        {
          label: '',
          template: (
            <ProjectDropdown topBar />
          )
        },
      ]
    },
  ];
  return (
    <div>
      <div className="card">
        <Sidebar
          visible={visible}
          position="left"
          onHide={() => setVisible(false)}
        >
          <Toast ref={toast} />

          <Link to={`/`} className="p-navbar-link">
            <h3 className="p-sidebar-content" onClick={()=>{deleteProjectInfo('all-project')}}>
              <i className="pi pi-server"></i>
              {t("all_projects")}
            </h3>
          </Link>

          <Link to={`/create-project`} className="p-navbar-link">
            <h3 className="p-sidebar-content" onClick={()=>{deleteProjectInfo('all-project')}}>
              <i className="pi pi-server"></i>
              {t("create_project")}
            </h3>
          </Link>
          {projects.map((val: any, i: any) => {
            return (
              <>
                <Tooltip id={`p-sidebar-content ${i}`} />
                <h3 className={`p-sidebar-content ${i}`} key={i} onClick={()=>{
                  deleteProjectInfo(val["project"]);
                }}>
                  <Link
                    to={`/project/${val["project"]["id"]}`}
                    className="p-navbar-link"
                    data-tooltip-id={`p-sidebar-content ${i}`}
                    data-tooltip-content={val["project"]["project_name"]}
                  >
                    {" "}
                    <i className="pi pi-server"></i>
                    {/*{val["project"]["project_name"]}*/}
                    {shortenName(val["project"]["project_name"])}

                  </Link>

                  <FaEdit
                    className="edit-icon mx-2 edit-icon"
                    onClick={() => {
                      navigate(
                        `/edit-project/${val["project"]["project_name"]}/${val["project"]["id"]}`
                      );
                    }}
                  />
                  <BsTrash
                    className="trash-icon mx-1"
                    onClick={() => {
                      confirmDelete(val["project"]["id"], val["project"]["project_name"])
                    }}
                  />
                </h3>
              </>
              // </Link>
            );
          })}
        </Sidebar>
        <div className="flex align-items-center">
          <Button
            icon="pi pi-align-justify"
            onClick={() => setVisible(true)}
            className="hamburger-icon"
          />
          <Menubar model={items} />
        </div>

        {/*<img*/}
        {/*  alt="logo"*/}
        {/*  src="/images/logo.png"*/}
        {/*  height="40"*/}
        {/*  className="p-navbar-logo"*/}
        {/*/>*/}

      </div>
    </div>
  );
};

export default SideNav;
